import { makeStyles } from "@material-ui/core";

export const css = makeStyles(() => ({
    modal: {
        textAlign: "center",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 30px",
    },
    header: {
        display: "flex",
        alignItems: "center",
        margin: "0 auto",
    },
    title: {
        fontWeight: "bold",
        margin: "20px auto",
    },
    closeButton: {
        zIndex: 1,
        position: "absolute",
        marginLeft: "65%",
        cursor: "pointer",
    },
    text: {
        fontSize: "18px",
        fontWeight: "700",
        marginBottom: "30px",
        textAlign: "center",
    }
}));
